export const CABYS_DEFAULT = '6339300000000';
export const ECONOMIC_ACTIVITY_DEFAULT = '552004';
export const MAX_PRODUCT_MASSIVE = 350;

export const exonerationDocumentsArray = [
  { code: '01', name: 'Compras autorizadas' },
  { code: '02', name: 'Ventas excentas a diplomáticos' },
  { code: '03', name: 'Autorizado por Ley especial' },
  { code: '04', name: 'Exenciones Dirección General de Hacienda' },
  { code: '05', name: 'Transitorio V' },
  { code: '06', name: 'Transitorio IX' },
  { code: '07', name: 'Transirorio XVII' },
  { code: '99', name: 'Otros' },
];
